import {Directive, ElementRef, Input, OnChanges, OnInit} from '@angular/core';
import {UserProfileService} from "./user-profile.service";

declare let iNet: any;

@Directive({
    selector: 'img[userAvatar]'
})
export class AvatarDirective implements OnInit, OnChanges {
    @Input() usercode: string = iNet.username;

    constructor(private _el: ElementRef) {}

    ngOnInit() {
        this._el.nativeElement.addEventListener('error', this._loadAvatarError.bind(this));
        this._setAvatar();
    }

    ngOnChanges() {
        this._setAvatar();
    }

    private _setAvatar() {
        if (!this.usercode) {
            this._loadAvatarError();
            return;
        }
        this._el.nativeElement.src = iNet.getUrl('system/userprofile/photo') + '?usercode=' + encodeURIComponent(this.usercode);
    }

    private _loadAvatarError() {
        this._el.nativeElement.src = UserProfileService.DEFAULT_AVATAR_URL;
    }
}
